import styled from '@emotion/styled';
import { css, Flex } from 'theme-ui';
import { BASIC_CONTAINER_WIDTH } from '../../consts/style-consts';
import { RegularAnchor } from '../../shared-styled/typography/Anchors';

export const Container = styled(Flex)(
  css({
    width: BASIC_CONTAINER_WIDTH,
    flexDirection: 'column',
    padding: '32px 0 40px 0',
    background: 'white',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
    borderRadius: '3px',
    marginTop: ['40px', '40px', '20px'],
  }),
);

export const CommonListLink = styled(RegularAnchor)(
  css({
    px: '36px',
    py: '12px',
    display: 'flex',
    gap: '8px',

    '&:hover': {
      backgroundColor: 'listElementHover',
      borderLeft: '5px solid',
      borderColor: 'secondaryGreen',
      px: '31px',
    },
  }),
);
